import { rem } from 'polished'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import { StyledModalImageThumbnail } from 'components/Luxkit/Modal/ModalImageThumbnail'
import { useGoogleMapsContext } from 'contexts/GoogleMapsContext'
import { getPlaceImageUrl } from 'tripPlanner/hooks/getPlaceImageUrl'

const CoverImage = styled.img`
  display: inline;
  object-fit: cover;
  width: 100%;
  height: ${rem(360)};
`

type Props = {
  placeId: string
  title: string
  maxWidth?: number
  maxHeight?: number
}
function SummaryGoogleImage({ maxHeight, maxWidth, placeId, title }: Props) {
  const [photoUrl, setPhotoUrl] = useState<string | null>(null)
  const { isLoaded, placesService } = useGoogleMapsContext()

  useEffect(() => {
    if (!placesService) return
    const fetchImageUrl = async () => {
      const url = await getPlaceImageUrl(
        placesService,
        placeId,
        'all',
        maxWidth,
        maxHeight,
      )
      setPhotoUrl(url)
    }
    fetchImageUrl()
  }, [placesService, placeId, maxHeight, maxWidth])

  if (!isLoaded || !photoUrl) return null

  return (
    <StyledModalImageThumbnail>
      <CoverImage src={photoUrl} alt={title} />
    </StyledModalImageThumbnail>
  )
}
export default SummaryGoogleImage
